import { ajaxCall } from "@/shared/connection/ajax-call";
import { handleErrorByMessage } from "@/shared/connection/with-store-error-handlers";

import { makeLogger } from "@/shared/consola";
// eslint-disable-next-line no-unused-vars
const logger = makeLogger("ticker-cart.service");

const TICKER_ENDPOINT = `/tickers`;

export const tickerCartService = {
    async getECProducts() {
        logger.trace("getECProducts start");
        try {
            const data = await ajaxCall.get(`${TICKER_ENDPOINT}/get-easy-cart-products`);
            logger.trace("getECProducts", "data", data);
            return { ...data, message: "SUCCESS" };
        } catch (error) {
            if (error.errorToken?.startsWith?.("ERR_INT_EASY_CART")) {
                logger.trace("getECProducts", "error", error);
                return { message: error.errorToken };
            } else {
                throw error;
            }
        }
    },
    getECFeed({ uuid }) {
        logger.trace("getECProductAccess");
        return ajaxCall
            .get(`${TICKER_ENDPOINT}/${uuid}/get-easy-cart-feed`)
            .catch(handleErrorByMessage());
    },
};
